import { render } from "./NullComponent.vue?vue&type=template&id=13254338&scoped=true"
import script from "./NullComponent.vue?vue&type=script&lang=js"
export * from "./NullComponent.vue?vue&type=script&lang=js"

import "./NullComponent.vue?vue&type=style&index=0&id=13254338&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13254338"]])

export default __exports__